import produce from 'immer';

import {
  CREATE_EMAIL_TEMPLATE_FAILURE,
  CREATE_EMAIL_TEMPLATE_SUCCESS,
  EDIT_EMAIL_TEMPLATE_FAILURE,
  EDIT_EMAIL_TEMPLATE_SEQUENCE_FAILURE,
  EDIT_EMAIL_TEMPLATE_SEQUENCE_SUCCESS,
  EDIT_EMAIL_TEMPLATE_SUCCESS,
  FETCH_EMAIL_TEMPLATE_FAILURE,
  FETCH_EMAIL_TEMPLATE_LIST_FAILURE,
  FETCH_EMAIL_TEMPLATE_LIST_SUCCESS,
  FETCH_EMAIL_TEMPLATE_SUCCESS,
} from '@actions/emailTemplate';

const initialState: IEmailTemplateStore = {
  templates: null,
  currentTemplate: null,
  error: null,
};

export default (state: IEmailTemplateStore = initialState, action: any) =>
  produce(state, (draftState: IEmailTemplateStore) => {
    switch (action.type) {
      case FETCH_EMAIL_TEMPLATE_LIST_SUCCESS:
      case EDIT_EMAIL_TEMPLATE_SEQUENCE_SUCCESS:
        draftState.templates = action.response;
        draftState.error = null;

        return;

      case FETCH_EMAIL_TEMPLATE_SUCCESS:
      case EDIT_EMAIL_TEMPLATE_SUCCESS:
        draftState.currentTemplate = action.response;
        draftState.error = null;

        return;

      case CREATE_EMAIL_TEMPLATE_SUCCESS:
        draftState.currentTemplate = null;
        draftState.error = null;

        return;

      case EDIT_EMAIL_TEMPLATE_FAILURE:
      case FETCH_EMAIL_TEMPLATE_FAILURE:
      case FETCH_EMAIL_TEMPLATE_LIST_FAILURE:
      case EDIT_EMAIL_TEMPLATE_SEQUENCE_FAILURE:
      case CREATE_EMAIL_TEMPLATE_FAILURE:
        draftState.error = action.error;

        return;
    }
  });
